<template>
  <div>
    <div class="step-subtitle d-none d-md-block mb-3">
      {{ $t('addQuestionTitle') }}:
    </div>
    <VCardText class="d-flex flex-column pa-0">
      <VTextarea
        v-model="textQuestion"
        class="questions mb-2"
        outlined
        dense
        rows="3"
        :label="$t('freeFormQuestion2')"
        :hint="`${$t('charactersLimit')} ${counter}`"
        :counter="counter"
        :error-messages="errors.question"
      />
      <div class="text-left">
        <VBtn
          color="success"
          class="mb-3 mt-n2 mb-md-4"
          elevation="0"
          :outlined="$vuetify.breakpoint.smAndDown"
          :disabled="!textQuestion || isTooLong"
          @click="addTextQuestion"
        >
          {{ $t('addQuestion') }}
        </VBtn>
      </div>
      <p v-if="showPreview" class="text-caption text-md-subtitle-2 mb-2" style="max-width: 37rem">
        {{ $t('textQuestionTip') }}
      </p>
    </VCardText>
  </div>
</template>
<script>
import ValidationMixin from '@/mixins/ValidationMixin';
import { questionTypes } from '@/enums';

export default {
  name: 'VacancyQuestionsLibraryText',
  mixins: [ValidationMixin],
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    showPreview: {
      type: Boolean,
      default: true,
      required: false,
    },
    isAiQuestions: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      textQuestion: '',
      isTooLong: false,
    };
  },
  computed: {
    counter() {
      return this.isAiQuestions ? 1500 : 250;
    },
  },
  watch: {
    textQuestion(value) {
      this.isTooLong = value && value.length > this.counter;
    },
  },
  methods: {
    async addTextQuestion() {
      if (!this.textQuestion) {
        return this.$toast.error(this.$t('enterQuestion'));
      }
      this.$emit('input', {
        id: `undefined-${Math.random()}`,
        type: questionTypes.TEXT,
        question: this.textQuestion,
      });
      this.$emit('save');
      this.textQuestion = '';
      if (this.$vuetify.mdAndUp) {
        return this.$toast.success(this.$t('questionAdded'));
      }
    },
  },
};
</script>
<style lang="scss">
  .questions .v-input__slot {
    background: white !important;
  }
</style>

<i18n locale="en" lang="yaml">
  addQuestionTitle: Add custom question
  ownQuestion: Custom question
  questionNotFound: Did not find question
  freeFormQuestion: Ask custom question
  textQuestionTip: The question will not be read out by the actor, but will be shown on the screen
  freeFormQuestion2: Ask custom question
  charactersLimit: The maximum number of characters is
  questionWordingTip: |-
    Try to ask clear and unambiguous questions.
    For example, when asked "did you attend college?",
    the applicant may answer "yes" or "no",
    or they may start to talk about their university, major, etc.
    Remember that during the interview, you will not be able to ask leading questions.
  addQuestion: Add question
  questionAdded: Question added
  enterQuestion: Enter question text
</i18n>

<i18n locale="ru" lang="yaml">
  addQuestionTitle: Добавление вопроса вручную
  ownQuestion: Свой вопрос
  questionNotFound: Не нашли вопрос
  freeFormQuestion: Задайте его в свободной форме
  textQuestionTip: Вопрос введенный вручную будет показан текстом на экране, а не озвучен диктором Мы рекомендуем включать не более 1-2 таких вопросов в интервью
  freeFormQuestion2: Задайте свой вопрос в свободной форме
  charactersLimit: Максимальное количество символов -
  questionWordingTip: |-
    Старайтесь формулировать ёмкие и однозначно воспринимаемые вопросы.
    Например, на вопрос "какое у вас образование?" соискатель может ответить "высшее",
    либо он расскажет о вузе специальности и т.п. Помните, что в процессе интервью
    вы не сможете задавать наводящие вопросы и корректировать ход мысли соискателя
  addQuestion: Добавить вопрос
  questionAdded: Вопрос добавлен
  enterQuestion: Введите текст вопроса
</i18n>
